<template>
<div class="modal-wrapper colored-modal-wrapper user-identity">

    <div class="modal" data-aos="fade-down" v-if="showUploadSelect">
 
        <div>
            <div class="modal-title modal-title-sm">
               <p>Ausweis hochladen</p>
            </div>

            <div class="modal-msg">
                <p>Wählen Sie, wie Sie Ihren Ausweis hochladen möchten: Sie können ein vorhandenes Foto aus Ihrer Galerie auswählen oder ein neues Bild mit der Kamera aufnehmen.</p>
            </div>

            <!-- captureMode: {{ captureMode }} -->

            <div class="buttons-wrapper">
                <button 
                    @click="selectUploadOption('gallery')" 
                    class="modal-btn modal-btn-sm modal-btn-white">
                    <p>Aus Galerie</p>
                </button>

                <button 
                    @click="selectUploadOption('camera')" 
                    class="modal-btn modal-btn-sm modal-btn-white">
                    <p>Kamera</p>
                </button>

                <button @click="showUploadSelect = false" class="modal-btn modal-btn-sm">
                    <p>Abbrechen</p>
                </button>
            </div>

        </div>

    </div>

    <div class="modal modal-lg" data-aos="fade-down" v-else>
        <div class="close-modal-btn" @click="closeModal()">
            <img src="../../assets/icons/close_icon.svg" />
        </div>

        <div class="signature-about" v-if="!mobile">
            <div class="modal-title modal-title-sm">
                <p>Datenschutzvollmacht</p>
            </div>
            <div class="signature-about-content"> 
             <p>
                    Autorisierungsformular<br>
                    {{formattedDate}}  
                    <br>
                    <span v-if="userInfo && userInfo.firstName && userInfo.lastName">
                        Vorname Nachname: {{userInfo.firstName}} {{userInfo.lastName}}
                    </span>
                    <br>
                    <span v-if="userInfo && userInfo.birthday">
                        Geburtstag: {{userInfo.birthday}}
                    </span>
                    <br>
                    <span v-if="userInfo && userInfo.address">
                       Adresse: {{userInfo.address}}
                    </span>
                    <span v-else>
                        [Adresse]
                    </span>
                    <br>

                    E-Mail-Adresse:
                    <span v-if="userInfo && userInfo.email">
                        {{userInfo.email}}
                    </span>
                    <span v-else>
                        [E-Mail]
                    </span>
                </p>

                <div ref="termsInfo" :style="maxHeightStyle">
                    <p>
                        Ich bevollmächtige CleanData (Rechtsträger: LEVELS AG, St. Galler Str. 5, CH-9042 Speicher, E-Mail: compliance@cleandata.ch) mich gegenüber datenverarbeitenden Stellen im In- und Ausland zu vertreten und in meinem Namen meine Datenschutzrechte geltend zu machen.
                    <br>
                        Dies umfasst insbesondere die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch und Datenportabilität gemäss:
                    </p>
                    
                    <ul>
                        <li>
                            <p>
                                <b>Art. 15–21 der EU-Datenschutz-Grundverordnung (DSGVO),</b>
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Art. 8–16 des revidierten Schweizer Datenschutzgesetzes (revDSG),</b>
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>dem California Consumer Privacy Act (CCPA/CPRA)</b> sowie
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>vergleichbaren Datenschutzgesetzen anderer Länder,</b> soweit anwendbar.
                            </p>
                        </li>
                    </ul>

                    <p>
                        CleanData ist berechtigt, Auskunfts- und Löschbegehren zu stellen und die dazu nötigen Schritte in meinem Namen vorzunehmen. 
                    <br>
                        Diese Vollmacht gilt ab Unterzeichnung und kann jederzeit per E-Mail widerrufen werden. Bereits eingeleitete Schritte bleiben wirksam.
                    </p>
                </div>
            </div>

            <div class="show-more" v-if="isOverflowing">
                <a @click="toggleShowMore">
                    {{ showMoreInfo ? 'Weniger anzeigen' : 'Mehr anzeigen' }}
                </a>
            </div>
        </div>

        <div class="identity-inputs">
            <div class="identity-input-title">
                <p>Identitätsprüfung</p> 
                <span>Damit deine Datenschutz-Anfragen bearbeitet werden können, müssen wir und die Unternehmen deine Identität sicherstellen. Dafür dient deine amtliche Ausweiskopie. </span>
            </div>

            <div class="identity-animation">
                <Vue3Lottie :animationData="cardAnimation" />
            </div> 

            <!-- //captureMode: {{ captureMode }} -->
 
            <div class="identity-input-row">
                <div class="identity-input-wrapper">
                    <div class="identity-input front-card" @click="this.$refs.frontIdImg.click()">
                    <!-- <div class="identity-input front-card" @click="openUploadSelect('front')">  -->
                        <div class="identity-card-img">
                            <img src="../../assets/icons/front_id_icon.svg" />
                        </div>
                        <p>Vorderseite</p>
                        <input type="file" id="frontImgInput" ref="frontIdImg" style="display: none" accept="image/*" @change="onFrontImgInput" />
                    </div>

                    <div v-if="frontImageUrl" class="image-input-info">
                        <p>{{frontImageName}}</p>
                    </div>
                </div>
                <div class="identity-input-wrapper">
                    <div class="identity-input back-card" @click="this.$refs.backIdImg.click();">
                    <!-- <div class="identity-input back-card" @click="openUploadSelect('back')">  -->
                        <div class="identity-card-img">
                            <img src="../../assets/icons/back_id_icon.svg" />
                        </div>
                        <p>Rückseite</p>
                        <input type="file" id="backImgInput" ref="backIdImg" style="display: none" accept="image/*" @change="onBackImgInput" />
                    </div>

                    <div v-if="backImageUrl" class="image-input-info">
                        <p>{{ backImageName }}</p>
                    </div>
                </div>
            </div>


            <div v-if="imagesErr" class="err-msg images-err-msg">
                <p>Personalausweis erforderlich</p>
            </div>

            <div class="identity-input-btns"> 
                <button v-if="loadingBtn" class="modal-btn modal-btn-sm">
                    <div class="loader"></div> 
                </button>

                <button v-else @click="submitIdentityInfo()" class="modal-btn modal-btn-sm">
                    <p>Weiter</p>
                </button> 
            </div>
        </div>
    </div>


</div>
</template>

<script>
import cardAnimation from '../../assets/animations/id-card-animation.json'
import axiosInstance from "../../axios"; 
export default {
    watch: {
        frontImageUrl() {
            this.checkImages();
        },
        backImageUrl() {
            this.checkImages();
        }
    },
    data() {
        return {
            showUploadSelect: false,
            selectedInputType: null,  
            captureMode: '',  

            showMoreInfo: false,
            fullHeight: 0,

            collapsedHeight: 0,
            isOverflowing: false,

            cardAnimation,

            frontImageUrl: null,

            backImageUrl: null,

            frontImageName: '',

            backImageName: '',

            imagesErr: false,

            userInfo:{  
                email: '',
                address: '', 
            },

            mobile: false,
        }
    },
    async mounted() {
        await this.getProfilelData();
        this.userInfo = this.userPersonalData; 

        if(this.userInfo.showDocumentsUploadWindow){
            this.fullHeight = this.$refs.termsInfo.scrollHeight;
        }else{ 
            this.$store.commit("application/setAddDocumentsModal", false); 
        }

        this.checkIfMobile(); 
        
        window.addEventListener("resize", this.checkIfMobile); 

        this.$nextTick(() => {
            this.checkOverflow();
        });
        window.addEventListener("resize", this.checkOverflow);
    },
    beforeUnmount() { 
        window.removeEventListener("resize", this.checkIfMobile); 
        window.removeEventListener("resize", this.checkOverflow);
    },
    computed: {
        formattedDate() {
         return this.formatDate(new Date());
        }, 

        maxHeightStyle() {
            if (!this.isOverflowing) {
                return {
                    maxHeight: "none"
                };
            }

            return {
                maxHeight: this.showMoreInfo ? `${this.fullHeight}px` : `${this.collapsedHeight}px`,
                transition: "max-height 0.3s ease",
                overflow: "hidden",
            };
        },
    },
    methods: {
        openUploadSelect(type) {
            if (this.mobile) {
                this.selectedInputType = type;
                this.showUploadSelect = true;
            } else { 
                if (type === 'front') this.$refs.frontIdImg.click();
                else this.$refs.backIdImg.click();
            }
        },

        selectUploadOption(option) {
            this.showUploadSelect = false;

            if (option === 'camera') {
                this.$nextTick(() => {
                    if (this.selectedInputType === 'front') {
                        const input = this.$refs.frontIdImg;
                        input.setAttribute('capture', this.captureMode);
                        input.click();
                    } else if (this.selectedInputType === 'back') {
                        const input = this.$refs.backIdImg;
                        input.setAttribute('capture', this.captureMode);
                        input.click();
                    }
                });
            } else {
                this.$nextTick(() => {
                    if (this.selectedInputType === 'front') this.$refs.frontIdImg.click();
                    else this.$refs.backIdImg.click();
                });
            }

            
        },

        toggleShowMore() {
            this.showMoreInfo = !this.showMoreInfo;
        },
        
        checkOverflow() {
            const el = this.$refs.termsInfo;
            if (el) {
                this.fullHeight = el.scrollHeight;

                const fontSize = parseFloat(getComputedStyle(el).fontSize) || 16;
                this.collapsedHeight = 15 * fontSize;

                this.isOverflowing = this.fullHeight > this.collapsedHeight;
            }
        },

        formatDate(date) {
            return `Datum: ${new Intl.DateTimeFormat('de-CH', { 
                day: '2-digit', month: 'long', year: 'numeric', 
                hour: '2-digit', minute: '2-digit', hour12: false 
            }).format(date).replace(',', ' um')}`;
        },

        checkIfMobile(){
            if(window.innerWidth <= 694){
                this.mobile = true;
                this.showMoreInfo = true;
            }else{
                this.mobile = false;
            }
        },

        closeModal() {
            this.$store.commit("application/setAddDocumentsModal", false);
        },

        checkImages() {
            this.imagesErr = !(this.frontImageUrl && this.backImageUrl);
        },

        onFrontImgInput(event) {
            const file = event.target.files[0];
            if (file && file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onload = (e) => { 
                    this.frontImageUrl = e.target.result;
                };
                reader.readAsDataURL(file);

                this.frontImageName = file.name;
            } else {
                this.frontImageName = '';
            }
        },

        onBackImgInput(event) {
            const file = event.target.files[0];
            if (file && file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.backImageUrl = e.target.result;
                };
                reader.readAsDataURL(file);

                this.backImageName = file.name;
            } else {
                this.backImageUrl = null;

                this.backImageName = '';
            }
        },

        base64ToFile(base64, filename) {
            return new Promise((resolve, reject) => {
                try {
                    const byteString = atob(base64.split(',')[1]);
                    const arrayBuffer = new ArrayBuffer(byteString.length);
                    const uintArray = new Uint8Array(arrayBuffer);

                    for (let i = 0; i < byteString.length; i++) {
                        uintArray[i] = byteString.charCodeAt(i);
                    }

                    const file = new File([uintArray], filename, {
                        type: "image/png"
                    });
                    resolve(file);
                } catch (error) {
                    reject("Error converting base64 to file: " + error);
                }
            });
        },

        submitIdentityInfo() {
            this.loadingBtn = true;

            if (!this.frontImageUrl || !this.backImageUrl) {
                this.imagesErr = true; 
                this.loadingBtn = false;
                return;
            }

            const formData = new FormData();
          
            this.base64ToFile(this.frontImageUrl, "front_card.png").then((frontFile) => {
                formData.append("idDocumentFront", frontFile); 

                this.base64ToFile(this.backImageUrl, "back_card.png").then((backFile) => {
                    formData.append("idDocumentBack", backFile); 
                 
                    axiosInstance({ requiresAuth: true }).post("/customer/documents/reVerify", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then(() => { 
                            this.$store.commit("application/setAddDocumentsModal", false); 
                            this.$store.commit("application/setSuccessProcessModal", true); 
                            this.$store.commit("application/setSuccessProcessTitle", 'Erfolgreich gesendet'); 
                            this.$store.commit("application/setSuccessProcessText", 'Wir verifizieren jetzt deine ID!'); 
                            this.checkUserIdentity();
                        })
                        .catch(error => {   
                            this.$store.commit("application/setAddSignatureModal", false);  
                            this.$store.commit("application/setErrorProcessModal", true); 
                            this.$store.commit("application/setErrorProcessTitle", 'Fehler bei der Verarbeitung der ID.'); 
                            this.$store.commit("application/setErrorProcessText", error.response.data.message); 
                            this.checkUserIdentity();
                        });
                });
            });
        
            this.loadingBtn = false;
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/modals.scss";

ul {
    list-style: none;
    padding-left: 16px;
    position: relative;

    li {
        position: relative;
        margin-bottom: 16px;

        &::before {
            content: '';
            position: absolute;
            left: -15px;
            top: 5px;
            width: 8px;
            height: 8px;
            background-color: #666666;
            border-radius: 50%;
        } 

        p{
            margin: 0 !important;
        }
    }
}

.close-modal-btn {
    cursor: pointer;
}

.user-identity {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
}

.images-err-msg {
    margin-bottom: 25px;
    text-align: center;
} 

.modal-lg {
    display: flex;
    justify-content: space-between;
    align-items: start;
    position: relative;
}

.signature-about {
    width: 45%;
}

.signature-input-wrapper {
    padding-top: 15px;
    width: 49%;
}

.modal-title {
    text-align: left;
    margin-bottom: 11px;
}

.signature-about-content {
    margin-bottom: 24px;

    p {
        color: #666666;
        font-size: 14px;
        transition: max-height 0.5s ease;
        overflow: hidden;

        &:first-child {
            margin-bottom: 30px;
        }
    }
}

.show-more {
    a {
        cursor: pointer;
        color: #FF3A67;
        font-size: 14px;
    }
}

.signature-input-title {
    p {
        color: #000000;
        font-size: 20px;
    }

    margin-bottom: 15px; 
    display: flex;
    align-items: center; 
}

.signature-wrapper {
    margin-bottom: 24px;
}

.signature-input {
    border: 1px solid #707070;
    border-radius: 20px;

    height: 281px !important;
}

.signature-input-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .modal-btn {
        margin: initial;
    }
}

/////
/// 
/// 
/// 
.modal-lg {
    display: flex;
    justify-content: space-between;
    align-items: start;
    position: relative;
}

.identity-about {
    width: 45%;
}

.identity-inputs {
    padding-top: 15px;
    width: 49%;
}

.modal-title {
    text-align: left;
    margin-bottom: 11px;
}

.identity-about-content {
    margin-bottom: 24px;

    p {
        color: #666666;
        font-size: 14px;
        transition: max-height 0.5s ease;
        overflow: hidden;

        &:first-child {
            margin-bottom: 30px;
        }
    }
}

.show-more {
    a {
        cursor: pointer;
        color: #FF3A67;
        font-size: 14px;
    }
}

.identity-input-title {
    p {
        color: #000000;
        font-size: 20px;
    }

    span{
        font-size: 14px;
    }

    margin-bottom: 15px;
}

.identity-animation {
    width: 213px;
    height: 213px;
    margin: 0 auto;
}

.identity-input-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 35px;

    .identity-input-wrapper {
        width: 45%;

        .identity-input {
            width: 100%;
            border: 1px dashed #707070;
            border-radius: 20px;
            padding: 8px 0;
            text-align: center;
            cursor: pointer;

            p {
                font-size: 12px;
                color: #000000;
                margin-top: 3px;
            }
        }

        .identity-card-img {
            width: 38px;
            height: 39px;
            margin: 0 auto;

            img {
                width: 100%;
            }
        }

        .image-input-info {
            margin-top: 10px;
            width: 100%;

            p {
                color: #FA3A67;
                font-size: 12px;
                word-break: break-word;
            }
        }
    }
}

.identity-input-btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .modal-btn {
        margin: initial;
    }
}

/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {}

/* 2304-1470 */
@media (min-width: 2304px) {}

/* 2470 - 1328 */
@media (min-width: 2470px) {}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {

    .signature-input-title p,
    .identity-input-title p {
        font-size: 22px;
    }

    .identity-input-title span{
        font-size: 16px;
    }

    .identity-input-row {
        margin-bottom: 50px;

        .identity-input-wrapper {

            .identity-input {
                border: 2px dashed #707070;
                padding: 10px 0;

                p {
                    font-size: 14px;
                    margin-top: 5px;
                }

                .identity-card-img {
                    width: 48px;
                    height: 49px;
                }
            }

            .image-input-info p {
                font-size: 14px;
            }
        }
    }
}

/*2573-1206*/
@media(min-width: 2573px) {}

/* 2880-1670 */
@media(min-width: 2880px) {

    .signature-input-title p,
    .identity-input-title p {
        font-size: 24px;
    } 

    .identity-input-title span{
        font-size: 18px;
    }

    .signature-about-content p,
    .show-more a {
        font-size: 16px;
    }

    .identity-animation {
        width: 225px;
        height: 225px;
    }

    .identity-input-row {
        margin-bottom: 60px;

        .identity-input-wrapper {

            .identity-input {
                border: 3px dashed #707070;
                padding: 12px 0;

                p {
                    font-size: 16px;
                    margin-top: 8px;
                }

                .identity-card-img {
                    width: 58px;
                    height: 59px;
                }
            }

            .image-input-info p {
                font-size: 16px;
            }
        }
    }
}

/* 3000-1870 */
@media(min-width: 3000px) {}

/*3200-1800*/
@media(min-width: 3200px) {

    .signature-input-title p,
    .identity-input-title p {
        font-size: 26px;
    } 

    .identity-input-title span{
        font-size: 20px;
    }

    .identity-animation {
        width: 235px;
        height: 235px;
    }

    .identity-input-row {
        margin-bottom: 70px;

        .identity-input-wrapper {

            .identity-input {
                padding: 15px 0;

                p {
                    font-size: 18px;
                    margin-top: 10px;
                }

                .identity-card-img {
                    width: 68px;
                    height: 69px;
                }
            }

            .image-input-info p {
                font-size: 18px;
            }
        }
    }
}

/*3360-1890 1695*/
@media(min-width:3360px) {

    .signature-about-content p,
    .show-more a {
        font-size: 18px;
    }
}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px) {

    .signature-input-title p,
    .identity-input-title p {
        font-size: 30px;
    } 

    .identity-input-title span{
        font-size: 22px;
    }

    .signature-about-content p,
    .show-more a {
        font-size: 20px;
    }

    .identity-animation {
        width: 260px;
        height: 260px;
    }

    .identity-input-row {
        margin-bottom: 80px;

        .identity-input-wrapper {

            .identity-input {
                padding: 18px 0;
                border: 4px dashed #707070;

                p {
                    font-size: 20px;
                    margin-top: 15px;
                }

                .identity-card-img {
                    width: 78px;
                    height: 79px;
                }
            }

            .image-input-info p {
                font-size: 20px;
            }
        }
    }
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {

    .modal {
        width: 1056px;
    }
 
}

/*1688-1080*/
@media(max-width: 1688px) {}

/*1680-1080*/
@media(max-width: 1680px) {}

/*1640-1080*/
@media(max-width: 1640px) {}

/* 1600 - 757 */
@media (max-width: 1600px) {  

    .identity-animation {
        width: 200px;
        height: 200px;
    }
}

/*1536-864*/
@media(max-width:1536px) {}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {}

/*1366-638*/
@media (max-width:1366px) {

    .signature-input-title p,
    .identity-input-title p {
        font-size: 18px;
    }  

    .identity-animation {
        width: 190px;
        height: 190px;
    }
}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {}

/* 1200-1920 */
@media (max-width:1200px) {}

/*1134x712*/
@media(max-width:1134px) {}

/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {
    .modal {
        width: 95%;
        padding: 40px 40px;
    }
}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {
    .signature-input-title p {
        font-size: 16px;
    } 

    .signature-about-content p,
    .show-more a {
        font-size: 12px;
    }

    .identity-animation {
        width: 180px;
        height: 180px;
    }
}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {}

/* 962x601 */
@media(max-width: 962px) {}

/* 900x1600 */
@media(max-width: 900px) {}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {
    .modal {
        width: 95%;
        padding: 35px 30px;
    } 

    .identity-animation {
        width: 170px;
        height: 170px;
    }
}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) { 

    .modal {
        padding: 35px 20px;
    }
}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {}

/*712-1138*/
@media(max-width:712px) {}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {
    .signature-about{
        display: none;
    }

    .modal {
        width: 90%;
        flex-direction: column;
        margin: 50px auto;
        //  max-height: 90vh;
        // overflow-y: scroll;
    }

    .signature-about .signature-about-content{
        max-height: 20vh; 
        overflow-y: scroll;
        margin-bottom: 0;
    }

    .signature-about-content p:first-child {
        margin-bottom: 20px;
    }

    .signature-about,
    .signature-input-wrapper,
    .identity-inputs {
        width: 100%
    }

    .signature-input-title { 
        justify-content: space-between;
        p {
            font-size: 18px;
        } 
    }
 
    .modal-btn-sm {
        width: 168px;
        padding: 12px 0;

        p {
            font-size: 14px;
        }
    }

    .identity-animation {
        width: 160px;
        height: auto;
    }

    .identity-input-row{
        margin-bottom: 30px;
    }
}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {}

/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {
    .signature-input-title p {
        font-size: 14px;
    } 

    .identity-animation {
        width: 150px; 
    }

    .identity-input-title p {
        font-size: 16px;
    }

    .identity-input-title span{
        font-size: 12px;
    }
}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {  
    .identity-input-title p {
        font-size: 14px;
    }

    .identity-input-title span{
        font-size: 10px;
    }

    .identity-input-row {
        .identity-input-wrapper {
            .identity-input {
                padding: 12px 0;
            }

            .image-input-info p {
                font-size: 10px;
            }
        }
    }
}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {
    .identity-input-title {
        margin-bottom: 0px;
    } 

    .modal-btn-sm {
        width: 140px;
    }

    .modal {
        padding: 25px 15px;
        margin: 0px auto;
    }
}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) {}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {  

    .modal-btn-sm {
        width: 120px;
    }

    .identity-animation {
        width: 140px;
        height: 140px;
    }
}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {  

    .modal-btn-sm {
        width: 110px;
    }
}

/* ip SE */
/*320x568*/
@media(max-width:320px) {  
}
</style>
